'use client';

import { useCallback } from 'react';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';

type UIElementKeys = 'recentTrades';

/**
 * Hook for managing loading state queue
 */
export const useLoadingQueue = () => {
	const setDriftStore = useDriftStore((s) => s.set);
	const getDriftStore = useDriftStore((s) => s.get);

	const addLoadingItemToQueue = useCallback(
		(props: { key: UIElementKeys }) => {
			setDriftStore((s) => {
				s.loadingElements = {
					...s.loadingElements,
					[props.key]: {
						isLoading: true,
					},
				};
			});
		},
		[setDriftStore]
	);

	const removeLoadingItemFromQueue = useCallback(
		(props: { key: UIElementKeys }) => {
			// Trigger callback for when item is cleared from queue
			getDriftStore().loadingElements[props.key]?.callback?.();

			setDriftStore((s) => {
				s.loadingElements = {
					...s.loadingElements,
					[props.key]: {
						isLoading: false,
					},
				};
			});
		},
		[setDriftStore, getDriftStore]
	);

	return { addLoadingItemToQueue, removeLoadingItemFromQueue };
};
